module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/voices/icon-voice-woman-30_db3a2209eb868c074e64db4b6342af77.png";